import decamelizeKeysDeep from "decamelize-keys-deep";
import {kulturnavApiCoreFetch} from "../app/kulturnavFetch";
import {apiCoreObjectToDAMSInput} from "../utility";
import {clientLog} from "../clientLog";
import {
    concatWithExisting,
    excludeThoseAlreadyListedAsKulturnav,
    inputWithCollectionIds,
    sourceToUniqueId
} from "../metadata/inputMapper";
import {damsSearch} from "../app/damsFetch";

/**
 * Method used to search for a subject, both in KulturNav and in the local DAMS database.
 * @param params    str     The name of the subject to search for
 * @param museums   Array   An array of museum IDs to limit the results to.
 * @param locale    str     The current locale
 * @param callback  function    The callback run when the search has completed.
 */
export const subjectsSearchHandler = async (params, museums, locale, callback) => {

    const searchParams = new URLSearchParams(
        decamelizeKeysDeep({
            q: `_title_:${params}`,
            fl: "title,id",
            sort: "title asc",
            expand: true,
            documentType: `("subject")`,
            museums: museums.join(","),
        })
    );

    const excludeDatasets = window._env_.REACT_APP_SUBJECTS_EXCLUDE_DATASETS;
    const excludeDatasetsClause = excludeDatasets.map(ed => `entity.dataset:!${ed}`).join(',');
    const removeDeprecatedKey = 'superconcept.status:853a2d84-5b2b-11e2-bcfd-0800200c9a66';

    Promise.all([
        kulturnavApiCoreFetch(
            `entityType:Concept,nativeCompoundName:${params},${removeDeprecatedKey},${excludeDatasetsClause}?displayValues=true&properties=entity.dataset,entity.fullCaption&lang=${locale}`
        )
            .then((json) => {
                return json.entities.map(j => apiCoreObjectToDAMSInput(j));
            })
            .catch((error) => {
                clientLog('error', error, 'subjectsSearchHandler');
                return Promise.resolve([]);
            }),

        damsSearch(searchParams).then((json) =>
            Promise.resolve(inputWithCollectionIds(json['models']))
        ),
    ]).then(([kulturnavResponse, damsResponse]) => {
        const damsLookup = sourceToUniqueId(damsResponse);
        const kulturnavMapped = concatWithExisting(kulturnavResponse, damsLookup);
        callback([
            ...kulturnavMapped,
            ...excludeThoseAlreadyListedAsKulturnav(damsResponse, kulturnavMapped),
        ]);
    }).catch(e => {
        clientLog('error', e, 'subjectssearchhandler');
        callback([]);
    });
};
